// extracted by mini-css-extract-plugin
module.exports = {"container":"PPMovies_container__2dgRo"};